import { MetricStateTypeId as MetricStateTypeId$1, CounterStateTypeId as CounterStateTypeId$1, FrequencyStateTypeId as FrequencyStateTypeId$1, GaugeStateTypeId as GaugeStateTypeId$1, HistogramStateTypeId as HistogramStateTypeId$1, SummaryStateTypeId as SummaryStateTypeId$1, counter as counter$1, frequency as frequency$1, gauge as gauge$1, histogram as histogram$1, summary as summary$1, isMetricState as isMetricState$1, isCounterState as isCounterState$1, isFrequencyState as isFrequencyState$1, isGaugeState as isGaugeState$1, isHistogramState as isHistogramState$1, isSummaryState as isSummaryState$1 } from '../../internal/metric/state.esm.js';

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
const MetricStateTypeId = MetricStateTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category symbols
 */
const CounterStateTypeId = CounterStateTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category symbols
 */
const FrequencyStateTypeId = FrequencyStateTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category symbols
 */
const GaugeStateTypeId = GaugeStateTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category symbols
 */
const HistogramStateTypeId = HistogramStateTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category symbols
 */
const SummaryStateTypeId = SummaryStateTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A `MetricState` describes the state of a metric. The type parameter of a
 * metric state corresponds to the type of the metric key (`MetricStateType`).
 * This phantom type parameter is used to tie keys to their expected states.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category constructors
 */
const counter = counter$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const frequency = frequency$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const gauge = gauge$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const histogram = histogram$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const summary = summary$1;

/**
 * @since 2.0.0
 * @category refinements
 */
const isMetricState = isMetricState$1;

/**
 * @since 2.0.0
 * @category refinements
 */
const isCounterState = isCounterState$1;

/**
 * @since 2.0.0
 * @category refinements
 */
const isFrequencyState = isFrequencyState$1;

/**
 * @since 2.0.0
 * @category refinements
 */
const isGaugeState = isGaugeState$1;

/**
 * @since 2.0.0
 * @category refinements
 */
const isHistogramState = isHistogramState$1;

/**
 * @since 2.0.0
 * @category refinements
 */
const isSummaryState = isSummaryState$1;

export { CounterStateTypeId, FrequencyStateTypeId, GaugeStateTypeId, HistogramStateTypeId, MetricStateTypeId, SummaryStateTypeId, counter, frequency, gauge, histogram, isCounterState, isFrequencyState, isGaugeState, isHistogramState, isMetricState, isSummaryState, summary };
